import script from "./DefEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./DefEditor.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__